/**
 * Cores e formatação dos KPIs de validação de endereços externos, compartilhadas entre a aba
 * Endereços Externos do CRUD de Candidatos e o relatório RELKpisEnderecosExternos.
 */

/** Mesmas cores do mapa em CRUDCandidatos, por código `valido` da validação. */
export const COR_VALIDACAO = {
  1: "#2E7D32",
  2: "#F57C00",
  3: "#1565C0",
  4: "#C62828",
  other: "#B71C1C",
  none: "#9E9E9E",
};

export function formatPct(v, locale) {
  const n = Number(v || 0);
  return n.toLocaleString(locale, { maximumFractionDigits: 1 }) + '%';
}

/** Duração da validação (ms): abaixo de 1 s em ms, acima em segundos com uma casa. */
export function formatTempoValidacao(ms, locale) {
  if (ms == null || ms === '' || !Number.isFinite(Number(ms))) return null;
  const n = Number(ms);
  return n < 1000
    ? Math.round(n) + ' ms'
    : (n / 1000).toLocaleString(locale, { maximumFractionDigits: 1 }) + ' s';
}
